// extracted by css-extract-rspack-plugin
export default {"popover":"popover-c6exTo","placeholder":"placeholder-FNapiy","muted":"muted-Ip6MlM"};